import {
  FALLBACK_LOCALE,
  SUPPORTED_LOCALES,
  type SupportedLocale,
} from '@shared/i18n/settings'

/**
 * Lingua iniziale dedotta dal browser, con fallback su quella di default.
 * Quando ci sarà una preferenza salvata dall'utente andrà consultata prima
 * di `navigator.languages`.
 */
export const resolveLocale = (): SupportedLocale => {
  if (typeof navigator === 'undefined') {
    return FALLBACK_LOCALE
  }

  const candidates = [ navigator.language, ...navigator.languages ?? [] ]
    .map((lang) => lang.toLowerCase())

  for (const lang of candidates) {
    // `it-IT` vale come `it`: si confronta prima la lingua completa e poi
    // il solo prefisso.
    const prefix = lang.split('-')[0]

    if (SUPPORTED_LOCALES.includes(lang as SupportedLocale)) {
      return lang as SupportedLocale
    }

    if (SUPPORTED_LOCALES.includes(prefix as SupportedLocale)) {
      return prefix as SupportedLocale
    }
  }

  return FALLBACK_LOCALE
}
